import { useEffect, useRef, useState } from "react";
import { houseLive, rothSummary, tvFloorSide, tvFloorOps } from "../../lib/api";

const usePoll = (fn, ms) => {
  const [d, setD] = useState(null);
  const f = useRef(fn);
  useEffect(() => {
    let dead = false;
    const pull = () => f.current().then((r) => !dead && setD(r)).catch(() => {});
    pull();
    const t = setInterval(pull, ms);
    return () => { dead = true; clearInterval(t); };
  }, [ms]);
  return d;
};

export const useHouseLive = () => usePoll(houseLive, 3000)?.live || [];
export const useRoth = () => usePoll(rothSummary, 60000);
export const useFloorSide = () => usePoll(tvFloorSide, 20000);
export const useFloorOps = () => usePoll(tvFloorOps, 5000);

export const STATUS_COLOR = { BUILDING: "#A78BFA", EXECUTING: "#2CF6B3", STUDYING: "#00F0FF" };
export const agoCt = (iso) => {
  if (!iso) return "";
  const m = (Date.now() - Date.parse(iso)) / 60000;
  return m < 1 ? "just now" : m < 60 ? `${Math.round(m)}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`;
};
export const ctTime = (iso) => (iso ? `${new Date(iso).toLocaleTimeString("en-US", { timeZone: "America/Chicago", hour: "numeric", minute: "2-digit" })} CT` : "");
